import {FormGroup, TextField, Button, MenuItem, Select, InputLabel, FormControl, Paper, Typography} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import {  useEffect, useState } from "react";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import {formatDate2, airportlist} from "./date.js"
import DateCalc from "./date";
import { fetchTrips, addTrip, fetchDest, fetchEmployees, fetchquotedatesonly } from "../api/customerapi";



const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8"
  },
  checkboxalign:{
     alignSelf: "center",
     justifyContent: "center",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  formgroup: {
      justifyContent: "center",   
  },
  textArea: {
      marginLeft: theme.spacing(12),
      marginRight: theme.spacing(14),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(15),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    input: {
        "&:invalid": {
          border: "red solid 2px"
        }
      },
    
  }));

const Tripdataentry = () => {

    const classes = useStyles();
    
    const preURL=document.referrer;
    const urlarray=preURL.split("/");
    const custid=urlarray[urlarray.length-1];

    //const dispatch=useDispatch();
    //const store=useStore();
  const { appData, loading } = useAppData();
    const [tripData, settripData] =useState({
          
          
      start_date_undecided: "No",
      primary_mobile_number:0,
      primary_destination: "Kashmir",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history:[],
      trip_owner:"Amit",
      quote_pending:true,
      quote_pending_time:new Date(),
      flight_sp:0,
    flight_cp:0,
    land_sp:0,
    land_cp:0,
    anc_sp:0,
    extra_sp:0,
    anc_cp: 0,
    extra_cp:0,
    visa_sp:0,
    visa_cp:0,
    cruise_sp:0,
    cruise_cp:0,
      follow_up:[{
          status: "Open",
          notes: "",
      }],
  });

  const [tData, settData]=useState(null);
  const [emp, setemp]=useState([])
  const [dest, setdest]=useState([])
  const [followupData, setfollowupData] =useState({
    status: "Open",
    id:1,
    notes:"",
    fuptype:"",
    createdAt:new Date()
});
  
  
const airportlist2=airportlist.sort((a, b) => (a.city > b.city) ? 1: -1);
  var { cuser, role } = GetRole();
  
  const getDest = async () => {
    try{
    const data = await fetchDest();
    const temp=data.data.filter(d=>"order" in d)
    setdest(temp[0].dest);
  }catch(err){
    console.log(err)
  }
  };

const getEmployees = async () => {
    try{
    const data = await fetchEmployees();
    //const custdatalistfromdb= data.data

    const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL" || emp.role == "Manager" || emp.role == "SME");
    const empshortname = empsplist.map((emp) => emp.short_name);
    setemp(empshortname);
}catch(err){
    console.log(err)
  }
  };
  
  useEffect(() => {
    //getTrips()
    getDest()
    getEmployees()
  }, [])

  var fupsomeDate = new Date();
  
    fupsomeDate.setDate(fupsomeDate.getDate()); 
  const fupy=fupsomeDate.getFullYear()
  const fupm=(fupsomeDate.getMonth()+1) < 10? ("0"+(fupsomeDate.getMonth()+1)) : (fupsomeDate.getMonth()+1)
  const fupdt=fupsomeDate.getDate() <10 ? ("0"+fupsomeDate.getDate()) : fupsomeDate.getDate()
  const fupfinalDate=(fupy+"-"+fupm+"-"+fupdt)
  
  const quotecheck2=async()=>{
    let temp=1
    const today=DateCalc(0)
    for(let i=0;i<tripData.quote.length;i++){
      //console.log(tripData.quote[i])
      const data=await fetchquotedatesonly(tripData.quote[i])
      //console.log(data.data[0])
      // console.log(tripData.quote_pending_time)
      // console.log(new Date(data.data[0].updatedAt).getTime())
      // console.log(new Date(tripData.quote_pending_time).getTime())
      if(data.data.length>0 && new Date(data.data[0].createdAt).getTime()>new Date(today).getTime()){
        temp=0
      }
      if(data.data.length>0 && new Date(data.data[0].updatedAt).getTime()>new Date(today).getTime()){
        temp=0
      }
    }
    //console.log(temp)
    return temp
  }
  
  const handleSubmit =async (e) => {
    try{
    e.preventDefault();
      let qp=0
    // if(followupData.fupautonote=="Quote shared" || followupData.fupautonote=="Asked to add flights. Shared quote with flights" || followupData.fupautonote=="Needed changes. Shared updated quote"){
    //   let ret2=await quotecheck2()
    //   console.log(ret2)
    //   if(ret2){
    //     qp=1
    //   }
    // }
          const finaltripData= {...tripData,cust_id:custid, follow_up:[{...followupData, new_date:new Date(followupData.date)}],last_updated_by:cuser,createdAt: new Date(), updatedAt: new Date(),
            quote_pending:qp,
            quote_pending_time: qp ?new Date():null};
          //dispatch(getCustomerbyId(custid));
          console.log(finaltripData);
          
         const addtripResponse= await addTrip(finaltripData);
         // dispatch(createCustomer(finalcustData));
         //console.log(addcustResponse.data.cust_id);
         if(addtripResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
             alert("New trip added with trip id "+addtripResponse.data.trip_id);
             window.location = ("/tripdataentry/"+addtripResponse.data.trip_id);
         }
         else{
             alert("Something went wrong. Contact support");
             window.location = ("/");
         }
        }catch(err){
            console.log(err)
          }
    
    }
    
  
  
    return (  
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Trip </Typography>
            <Typography variant="h6" align="center" className={classes.headertext}> {" ( Customer Id:" + custid+")"}</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Trip Owner" required value={tripData.trip_owner} onChange={(e)=> settripData({...tripData, trip_owner: e.target.value})}>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                <MenuItem value={"Abhishek"}>Abhishek</MenuItem>
                <MenuItem value={"Asgar"}>Asgar</MenuItem>
                <MenuItem value={"NitinK"}>NitinK</MenuItem>
                <MenuItem value={"Yadvinder"}>Yadvinder</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
                    
                
                </Select>
                </FormControl>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="primary destination">Primary Destination</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="primary destination" required value={tripData.primary_destination} onChange={(e)=> settripData({...tripData, primary_destination: e.target.value})}>
                {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                </Select>
                </FormControl>
                <TextField required variant="standard"  type="date" label="Start Date"   inputProps={{ min: fupfinalDate }} InputLabelProps={{ shrink: true }} value={tripData.trip_start_date} className={classes.textField}  onChange={(e)=> settripData({...tripData, trip_start_date: e.target.value})}/>
               
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="multidest">Multiple Destinations?</InputLabel>
                <Select defaultValue="No" classname={classes.textField} labelId="multidest" value={tripData.multi_destinations} onChange={(e)=> settripData({...tripData, multi_destinations: e.target.value})}>
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Secondary Destinations">Secondary Destination</InputLabel>
                <Select displayEmpty disabled={tripData.multi_destinations=="Yes" ? 0 : 1} classname={classes.textField} labelId="Secondary Destinations" value={tripData.secondary_destinations} onChange={(e)=> settripData({...tripData, secondary_destinations: e.target.value})}>
                {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                </Select>
                </FormControl>
                {/* <TextField variant="standard"  label="Secondary Destinations"  disabled={tripData.multi_destinations=="Yes" ? 0 : 1} value={tripData.secondary_destinations} className={classes.textField} onChange={(e)=> settripData({...tripData, secondary_destinations: e.target.value})}/> */}
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Start date undecided">Start date undecided?</InputLabel>
                <Select defaultValue="No" classname={classes.textField} labelId="Start date undecided" value={tripData.start_date_undecided} onChange={(e)=> settripData({...tripData, start_date_undecided: e.target.value})}>
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                
                </Select>
                </FormControl>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Adults"># Adults (number)</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Adults" value={tripData.number_adults} onChange={(e)=> settripData({...tripData, number_adults: e.target.value})}>
                    <MenuItem value={1}>1 </MenuItem>
                    <MenuItem value={2}>2 </MenuItem>
                    <MenuItem value={3}>3 </MenuItem>
                    <MenuItem value={4}>4 </MenuItem>
                    <MenuItem value={5}>5 </MenuItem>
                    <MenuItem value={6}>6 </MenuItem>
                    <MenuItem value={7}>7 </MenuItem>
                    <MenuItem value={8}>8 </MenuItem>
                    <MenuItem value={9}>9 </MenuItem>
                    <MenuItem value={10}>10 </MenuItem>
                    <MenuItem value={11}>11 </MenuItem>
                    <MenuItem value={12}>12 </MenuItem>
                    <MenuItem value={13}>13 </MenuItem>
                    <MenuItem value={14}>14 </MenuItem>
                    <MenuItem value={15}>15 </MenuItem>
                    <MenuItem value={16}>16 </MenuItem>
                    <MenuItem value={17}>17 </MenuItem>
                    <MenuItem value={18}>18 </MenuItem>
                    <MenuItem value={19}>19 </MenuItem>
                    <MenuItem value={20}>20 </MenuItem>
                    <MenuItem value={21}>21 </MenuItem>
                    <MenuItem value={22}>22 </MenuItem>
                    <MenuItem value={23}>23 </MenuItem>
                    <MenuItem value={24}>24 </MenuItem>
                    <MenuItem value={25}>25 </MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Child"># Child/Infant (number)</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Child" value={tripData.number_child} onChange={(e)=> settripData({...tripData, number_child: e.target.value})}>
                    <MenuItem value={0}>0 </MenuItem>   
                    <MenuItem value={1}>1 </MenuItem>
                    <MenuItem value={2}>2 </MenuItem>
                    <MenuItem value={3}>3 </MenuItem>
                    <MenuItem value={4}>4 </MenuItem>
                    <MenuItem value={5}>5 </MenuItem>
                    <MenuItem value={6}>6 </MenuItem>
                    <MenuItem value={7}>7 </MenuItem>
                    <MenuItem value={8}>8 </MenuItem>
                    <MenuItem value={9}>9 </MenuItem>
                    <MenuItem value={10}>10 </MenuItem>
                    <MenuItem value={11}>11 </MenuItem>
                    <MenuItem value={12}>12 </MenuItem>
                    <MenuItem value={13}>13 </MenuItem>
                    <MenuItem value={14}>14 </MenuItem>
                    <MenuItem value={15}>15 </MenuItem>
                    <MenuItem value={16}>16 </MenuItem>
                    <MenuItem value={17}>17 </MenuItem>
                    <MenuItem value={18}>18 </MenuItem>
                    <MenuItem value={19}>19 </MenuItem>
                    <MenuItem value={20}>20 </MenuItem>
                </Select>
                </FormControl>
            <TextField variant="standard"  label="Total Pax"  value={tripData.number_adults+tripData.number_child} className={classes.textField} disabled/>
            
            <TextField
            required={"number_child" in tripData && tripData.number_child>0?1:0}
            variant="standard"
            label={"Child Age"}
            helperText={"Enter child age separated by commas"}
            InputLabelProps={{ shrink: true }}
            value={tripData.child_age}
            className={classes.textField4}
            onChange={(e) =>
              settripData({ ...tripData, child_age: e.target.value })
            }
          />
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Type of vacation">Type of Vacation</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Type of vacation" value={tripData.type_of_vacation} onChange={(e)=> settripData({...tripData, type_of_vacation: e.target.value})}>
                    <MenuItem value={"Honeymoon"}>Honeymoon</MenuItem>
                    <MenuItem value={"Anniversary"}>Anniversary</MenuItem>
                    <MenuItem value={"Birthday"}>Birthday</MenuItem>
                    <MenuItem value={"Break"}>Break</MenuItem>
                    <MenuItem value={"Children-Special"}>Children-Special</MenuItem>
                    <MenuItem value={"Nothing-Special"}>Nothing-Special</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Duration">Duration (number)</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Duration" value={tripData.duration} onChange={(e)=> settripData({...tripData, duration: e.target.value})}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                    <MenuItem value={13}>13</MenuItem>
                    <MenuItem value={14}>14</MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Trip Status">Trip Status</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Trip Status" value={tripData.trip_status} onChange={(e)=> settripData({...tripData, trip_status: e.target.value})}>
                    <MenuItem value={"New"}>New</MenuItem>
                    <MenuItem value={"Active"}>Active</MenuItem>
                   
                </Select>
                </FormControl>
               
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Channel">Channel *</InputLabel>
                <Select classname={classes.textField} required labelId="Channel" value={tripData.trip_channel} onChange={(e)=> settripData({...tripData, trip_channel: e.target.value})}>
                    <MenuItem value={"Facebook"}>Facebook</MenuItem>
                    <MenuItem value={"Instagram"}>Instagram</MenuItem>
                    <MenuItem value={"TripCrafters"}>TripCrafters</MenuItem>
                    <MenuItem value={"TripClap"}>TripClap</MenuItem>
                    <MenuItem value={"PayTM"}>PayTM</MenuItem>
                    <MenuItem value={"Reference"}>Reference</MenuItem>
                    <MenuItem value={"Tripoto"}>Tripoto</MenuItem>
                    <MenuItem value={"Organic"}>Organic</MenuItem>
                    <MenuItem value={"Email"}>Email</MenuItem>
                    <MenuItem value={"Meta"}>Meta</MenuItem>
                     <MenuItem value={"Poptin"}>Poptin</MenuItem>
                    <MenuItem value={"Manual"}>Manual</MenuItem>
                    <MenuItem value={"Unknown"}>Others</MenuItem>
                </Select>
                </FormControl>
                <TextField variant="standard"  label="Campaign"   value={tripData.trip_campaign} className={classes.textField}  onChange={(e)=> settripData({...tripData, trip_campaign: e.target.value})}/>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Trip Stage">Trip Stage</InputLabel>
                <Select classname={classes.textField} labelId="Trip Stage" value={tripData.trip_stage} onChange={(e)=> settripData({...tripData, trip_stage: e.target.value})}>
                    <MenuItem value={"Flight/Train booked"}>Flight/Train booked</MenuItem>
                    <MenuItem value={"Definitely going"}>Definitely going</MenuItem>
                    <MenuItem value={"Plan in progress"}>Plan in progress</MenuItem>
                    <MenuItem value={"Still dreaming"}>Still dreaming</MenuItem>
                    <MenuItem value={"Looking for info"}>Looking for info</MenuItem>
                   
                </Select>
                </FormControl>
                
               
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
        <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="flightreq">Flight Required?</InputLabel>
            <Select
              classname={classes.textField}
              labelId="flightreq"
              value={tripData.flight_required?true:false}
              onChange={(e)=> settripData({...tripData, flight_required: e.target.value})}
            >
              
              <MenuItem value={false}>false</MenuItem>
              <MenuItem value={true}>true</MenuItem>
            
            </Select>
          </FormControl>
        
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="sourceairport">Source Airport (Airport code only)</InputLabel>
            <Select
              classname={classes.textField}
              displayEmpty
              labelId="sourceairport"
              value={tripData.lead_source_airport}
              required={role=="Admin"?0:1}
              onChange={(e)=> settripData({...tripData, lead_source_airport: e.target.value})}
              inputProps={{className: classes.input, pattern:"[A-Z]{3}"}}
              InputLabelProps={{ shrink: true }}
            >
              
              <MenuItem value={"DNK"}>DNK</MenuItem>
              {airportlist2.map(data=>
                    <MenuItem value={data.airport}>{data.airport}</MenuItem>
                  )}
            
            </Select>
          </FormControl>
        </FormGroup>


            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Requirements (shown to customer)"  value={tripData.trip_requirements} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> settripData({...tripData, trip_requirements: e.target.value})}/>
            </FormGroup>

            
            <Typography variant="h4" align="center" className={classes.headertext}> Add Followup</Typography>
           
            
            
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Followup Status</InputLabel>
                <Select defaultValue="Open" disabled className={classes.textField} labelId="status" required onChange={(e)=> setfollowupData({...followupData, status: e.target.value})}>
                    <MenuItem value={"Open"}>Open</MenuItem>
                    <MenuItem value={"Closed"}>Closed</MenuItem>  
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="fuptype">Followup Type</InputLabel>
                <Select  className={classes.textField} labelId="fuptype" 
                 required={
                tripData.trip_status == "Closed" ||
                tripData.trip_status == "Cancelled" ||
                tripData.trip_status == "Converted" ||
                tripData.trip_status == "Booked Outside" ||
                tripData.trip_status == "Dropped After Booking"
                  ? null
                  : 1
              }
                onChange={(e)=> setfollowupData({...followupData, fuptype: e.target.value})}>
                    <MenuItem value={"Share first quote"}>Share first quote</MenuItem>
                    <MenuItem value={"Share revised quote"}>Share revised quote</MenuItem>
                    <MenuItem value={"Quote feedback"}>Quote feedback</MenuItem>
                    <MenuItem value={"Ask for payment"}>Ask for payment</MenuItem>
                    <MenuItem value={"Voucher or Confirmation pending"}>Voucher or Confirmation pending</MenuItem> 
                    <MenuItem value={"Trip Feedback"}>Trip Feedback</MenuItem> 
                    <MenuItem value={"Others"}>Others</MenuItem> 
                    
                
                </Select>
                </FormControl>
                </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  type="date" label="Followup Date"   inputProps={{ min: fupfinalDate }} 
                required={
              tripData.trip_status == "Closed" ||
              tripData.trip_status == "Cancelled" ||
              tripData.trip_status == "Converted" ||
              tripData.trip_status == "Booked Outside" ||
              tripData.trip_status == "Dropped After Booking"
                ? null
                : 1
            }
                className={classes.textField} InputLabelProps={{ shrink: true }} onChange={(e)=> setfollowupData({...followupData, date: e.target.value, new_date:new Date(e.target.value)})}/>
                <TextField variant="standard"  type="time" label="Followup Time"   
                required={
              tripData.trip_status == "Closed" ||
              tripData.trip_status == "Cancelled" ||
              tripData.trip_status == "Converted" ||
              tripData.trip_status == "Booked Outside" ||
              tripData.trip_status == "Dropped After Booking"
                ? null
                : 1
            }
                className={classes.textField} InputLabelProps={{ shrink: true }} onChange={(e)=> setfollowupData({...followupData, time: e.target.value})} />
               
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="fupautonote">Canned Notes</InputLabel>
            <Select
              className={classes.textField}
              labelId="fupautonote"
              required={role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts"?0:1}
              onChange={(e) =>
                setfollowupData({
                  ...followupData,
                  fupautonote: e.target.value,
                  notes: e.target.value,
                })
              }
            >
            <MenuItem value={"Call not picked"}>Call not picked</MenuItem>
            <MenuItem value={"Call not picked. WA sent"}>Call not picked. WA sent</MenuItem>
              <MenuItem value={"Call not picked and no response on Whatsapp"}>
                Call not picked and no response on Whatsapp
              </MenuItem>
              <MenuItem value={"Need to share first quote"}>Need to share first quote</MenuItem>
              <MenuItem
                value={"Asked to add flights. Shared quote with flights"}
              >
                Asked to add flights. Shared quote with flights
              </MenuItem>
              {/* <MenuItem value={"Fup done manually"}>Fup done manually</MenuItem> */}
              <MenuItem value={"Quote shared"}>Quote shared</MenuItem>
              <MenuItem value={"Yet to view quote"}>Yet to view quote</MenuItem>
              <MenuItem value={"Need changes. Need to share updated quote"}>
                Need changes. Need to share updated quote
              </MenuItem>
              <MenuItem value={"Needed changes. Shared updated quote"}>
                Needed changes. Shared updated quote
              </MenuItem>
              <MenuItem value={"Will let you know tomorrow"}>
                Will let you know tomorrow
              </MenuItem>
              <MenuItem value={"Will let you know"}>
                Will let you know
              </MenuItem>
              <MenuItem value={"Will let you know within 2-3 days"}>
                Will let you know within 2-3 days
              </MenuItem>
              <MenuItem value={"Will let you know within a week"}>
                Will let you know within a week
              </MenuItem>
              <MenuItem value={"Asked to call later"}>
                Asked to call later
              </MenuItem>
              <MenuItem value={"Asked to call later after a few days"}>
                Asked to call later after a few days
              </MenuItem>
              <MenuItem value={"Asked to call later after a week"}>
                Asked to call later after a week
              </MenuItem>
              <MenuItem value={"Our quote is costly. Shared other options"}>
                Our quote is costly. Shared other options
              </MenuItem>
              <MenuItem value={"Budget issue. Will let us know"}>
                Budget issue. Will let us know
              </MenuItem>
              <MenuItem value={"Budget issue. Shared other options"}>
                Budget issue. Shared other options
              </MenuItem>
              <MenuItem value={"Comparing packages with other agencies"}>
                Comparing packages with other agencies
              </MenuItem>
              <MenuItem value={"Okay with package. Will tell the final decision"}>
              Okay with package. Will tell the final decision
              </MenuItem>
              <MenuItem value={"Plan on hold"}>Plan on hold</MenuItem>
              <MenuItem value={"No response after multiple follow ups"}>
                No response after multiple follow ups
              </MenuItem>
              <MenuItem value={"Will call you back if we are interested"}>
                Will call you back if we are interested
              </MenuItem>
              <MenuItem value={"Everything finalized. Awaiting payment"}>
                Everything finalized. Awaiting payment
              </MenuItem>
              {/* <MenuItem value={"Asked to cancel-on call"}>
                Asked to cancel-on call
              </MenuItem>
              <MenuItem value={"Asked to cancel-on whatsapp"}>
                Asked to cancel-on whatsapp
              </MenuItem> */}
              <MenuItem value={"Manual Cancellation"}>
                Manual Cancellation
              </MenuItem>
              <MenuItem value={"Booked Outside"}>
                Booked Outside
              </MenuItem>
              <MenuItem value={"Asked to postpone"}>
                Asked to postpone
              </MenuItem>
              <MenuItem value={"Plan on hold"}>
                Plan on hold
              </MenuItem>
              <MenuItem value={"Need to share voucher or tickets"}>
                Need to share voucher or tickets
              </MenuItem>
              <MenuItem value={"Need to share insurance"}>
                Need to share insurance
              </MenuItem>
              <MenuItem value={"Need to confirm booking with supplier"}>
                Need to confirm booking with supplier
              </MenuItem>
              <MenuItem value={"Need to make payment to supplier"}>
                Need to make payment to supplier
              </MenuItem>
              <MenuItem value={"Data entry only"}>
                Data entry only
              </MenuItem>
              <MenuItem value={"Call not needed. Msg dropped"}>
              Call not needed. Msg dropped
              </MenuItem>
              
            </Select>
          </FormControl>
        </FormGroup>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Notes"  className={classes.textArea} value={followupData.notes} fullWidth multiline rows={2} onChange={(e)=> setfollowupData({...followupData, notes: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href={"/custdataentry/"+custid} variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                
            </FormGroup>
              
            </form>
                                            
                        
            </Paper>
    );

   
}
 
export default Tripdataentry;

